// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 1896) return "static/chunks/1896-03240061522ea79f.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1647":"169863254c4d0d62","3562":"f33d1e3d8cc4c63c","3693":"2af488f76fe76f37","3714":"eb6073ca7489eaf2","4516":"75b9dc2a027cdf01","4707":"565a9946fb079feb","7123":"4790f3ed414747d0","7943":"c5c260453cedf051","8803":"1d04d7431058ffed"}[chunkId] + ".js";
};